export default function SectionLabel({ children, testId }) {
    return (
        <div
            data-testid={testId}
            className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.28em] font-semibold text-[#00B7FF]"
        >
            <span className="w-8 h-px bg-gradient-to-r from-transparent via-[#1E90FF] to-[#00B7FF]" />
            <span>{children}</span>
        </div>
    );
}
